import { render } from "./InspectionInput.vue?vue&type=template&id=8fd54d48"
import script from "./InspectionInput.vue?vue&type=script&lang=js"
export * from "./InspectionInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__